import React from 'react'
import { bool, func, object, string } from 'prop-types'

import ButtonStandardArrow from '@/component/Primitive/ButtonStandardArrow'
import Container from '@/component/Primitive/Container'
import FieldTemplate from '@/component/Primitive/FieldTemplate'
import Inline from '@/component/Primitive/Inline'
import Notification from '@/component/Primitive/Notification'
import Stack from '@/component/Primitive/Stack'
import TextControl from '@/component/Primitive/TextControl'

const LoginForm = ({
  formData,
  onChange,
  onSubmit,
  loading,
  error,
  success,
  validation
}) => (
  <form onSubmit={onSubmit}>
    <Container gutter center size="m">
      <Stack gap="l">
        <Stack gap="m">
          <FieldTemplate
            label="Email address"
            required
            controlName="emailAddress"
            feedback={validation && validation.emailAddress}
            status={validation && validation.emailAddress && 'error'}
          >
            <TextControl
              type="email"
              name="emailAddress"
              required
              onChange={onChange}
              value={formData.emailAddress}
              disabled={loading || success}
              autoComplete="email"
            />
          </FieldTemplate>
        </Stack>

        {error && <Notification status="error">{error}</Notification>}
        {success && (
          <Notification status="success">
            Please check your email to finish the login
          </Notification>
        )}

        <Inline fullWidth justify="spaceBetween">
          <ButtonStandardArrow
            type="submit"
            loading={loading}
            disabled={success}
          >
            Continue
          </ButtonStandardArrow>
        </Inline>
      </Stack>
    </Container>
  </form>
)

LoginForm.propTypes = {
  formData: object,
  onChange: func,
  onSubmit: func,
  error: string,
  validation: object,
  loading: bool,
  success: bool
}

export default LoginForm
